'use client'

import React, { useState, useRef, useEffect } from 'react'
import styles from './quick-link2.module.scss'
import QuickLinkWrapper from './quick-link-wrapper'

const QuickLinks = ({ productPageResponse, segmentEventCommonProperties }) => {
  const [isSticky, setIsSticky] = useState(false)
  const [windowWidth, setWindowWidth] = useState(0)
  const [isQuickLinksVisible, setIsQuickLinksVisible] = useState(false)
  const quickLinksSectionRef = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsQuickLinksVisible(true)
          }
        })
      },
      { threshold: 1.0 } // Trigger when the section is fully visible
    )

    const currentRefValue: any = quickLinksSectionRef.current
    if (currentRefValue) {
      observer.observe(currentRefValue)
    }

    return () => {
      if (currentRefValue) {
        observer.unobserve(currentRefValue)
      }
    }
  }, [])

  return (
    <div
      id="quickLinksSection"
      ref={quickLinksSectionRef}
      className={`${styles.container} ${isSticky ? styles.isSticky : styles.isNotSticky}`}>
      <QuickLinkWrapper
        productPageResponse={productPageResponse}
        updateIsSticky={setIsSticky}
        quickLinksRef={quickLinksSectionRef}
        segmentEventCommonProperties={segmentEventCommonProperties}
        windowWidth={windowWidth}
        isQuickLinksVisible={isQuickLinksVisible}
      />
    </div>
  )
}

export default QuickLinks
